import { gql } from '@apollo/client';
import TENANT_SUPPLIER from 'api/fragments/TENANT_SUPPLIER';
const UPDATE_TENANT_SUPPLIER = gql `
  ${TENANT_SUPPLIER}
  mutation UpdateTenantSupplier(
    $supplierId: ID!
    $shortName: String
    $fullName: String
    $code: String
    $vatNumber: String
    $countryOfOrigin: String
    $addressPostalCode: String
    $addressCity: String
    $addressStreet: String
    $addressNumber: String
    $emailAddress: String
    $contactPhone: String
  ) {
    updateSupplier(
      supplierId: $supplierId
      shortName: $shortName
      fullName: $fullName
      code: $code
      vatNumber: $vatNumber
      countryOfOrigin: $countryOfOrigin
      addressPostalCode: $addressPostalCode
      addressCity: $addressCity
      addressStreet: $addressStreet
      addressNumber: $addressNumber
      emailAddress: $emailAddress
      contactPhone: $contactPhone
    ) {
      supplier {
        ...TenantSupplierFragment
      }
    }
  }
`;
export default UPDATE_TENANT_SUPPLIER;
